import type { IInventoryModalItem } from './data';

import { Box, HStack, Text } from '@/components';
import Error from '@/svgs/products/error.svg';
import Tick from '@/svgs/products/tick.svg';

const InventoryModalItem: IInventoryModalItem = ({ inventoryItem }) => {
  return (
    <HStack gap="11px" justify="center">
      <Box>{inventoryItem.is_available ? <Tick /> : <Error />}</Box>
      <Text fontSize={{ base: 'sm', md: 'lg' }} color="text">
        {inventoryItem.warehouse_name}
      </Text>
    </HStack>
  );
};

export default InventoryModalItem;
